import {
	GET_DISTRICTS,
	ADD_DISTRICT,
	GET_COUNTIES,
	DELETE_DISTRICT,
	UPDATE_DISTRICT
} from '../../Actions/Admin/ManageDistrictActions';

const initialState = {
	districts: [],
	counties: []
};
export const reducer = (state = initialState, action) => {
	switch (action.type) {
		case GET_DISTRICTS:
			return {
				...state,
				loading: true,
				districts: action.payload
			};
		
		case ADD_DISTRICT:
			return {
				...state,
				districts: action.payload
			};
		case DELETE_DISTRICT:
			return {
				...state,
				districts: action.payload
			};
		case GET_COUNTIES:
			return {
				...state,
				counties: action.payload
			};
		case UPDATE_DISTRICT:
			return {
				...state,
				districts: action.payload
			};
		default:
			return state;
	}
};
